import React from 'react'
import { Grid, Typography, makeStyles } from '@material-ui/core'

import { ImageProduct } from './ImageProduct'

const useStyles = makeStyles({
  row: {
    gap: 8,
    display: 'flex',
    alignItems: 'center',
    overflow: 'hidden',
  },
})

export function RowOption({ option }) {
  const classes = useStyles()

  return (
    <Grid className={classes.row}>
      <Grid>
        <ImageProduct product={option} dimensions={{ width: 60, height: 60 }} />
      </Grid>
      <Typography variant="body1">{option.name}</Typography>
    </Grid>
  )
}
